import { useDispatch } from 'react-redux'
import * as Actions from 'redux/actions'

import { useAuth } from './UseAuth'
import { message } from 'antd'
import { useCallback } from 'react'
import { useCurrentWorkspaceId } from './useCurrentWorkspaceId'
import { HOME_PATH } from 'paths'
import { useModals } from 'almanac-ui/Modal'
import { useHistory } from 'react-router-dom'
import { inSuperAdminMode } from 'utils/workspaceUtils'

export const useSuperAdmin = () => {
  const dispatch = useDispatch()
  const auth = useAuth()
  const currentWorkspaceId = useCurrentWorkspaceId()
  const history = useHistory()
  const { closeAllModals } = useModals()

  const enterSuperAdminMode = useCallback(() => {
    dispatch(
      Actions.authMerge({
        auth: {
          superAdminMode: currentWorkspaceId,
        },
      }),
    )
  }, [currentWorkspaceId, dispatch])

  const exitSuperAdminMode = useCallback(() => {
    dispatch(
      Actions.authMerge({
        auth: {
          superAdminMode: null,
        },
      }),
    )
    closeAllModals()
    message.destroy()
    history.push(HOME_PATH)
  }, [dispatch, history]) // eslint-disable-line react-hooks/exhaustive-deps

  const superAdminMode = inSuperAdminMode(currentWorkspaceId, auth)

  return {
    exitSuperAdminMode,
    enterSuperAdminMode,
    superAdminMode,
  }
}
